import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const etherscan = defineConnector({
  identifier: "etherscan",
  name: "Etherscan",
  tagLine: "Ethereum blockchain explorer API",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.etherscan\\.io/.*",
  auth: (app) => queryAuth([{ name: "apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Etherscan](https://etherscan.io/myapikey), open **API Keys** in your account and add a new key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.etherscan.io/v2/api?chainid=1&module=stats&action=ethprice",
      expectedBodyContains: '"status":"1"',
    }),
  },
});
